<template>
  <!-- INFO: This Vue component is used for both large and compact breakpoints, and corresponds with 2 tag files: navUtilityBarB2cLargeContainer.tag and navUtilityBarB2cCompactContainer.tag  -->
  <ul
    class="list-none col-span-3 z-20 pointer-events-auto col-start-10 lg:col-span-5 row-start-1 lg:col-start-8 flex gap-3 px-2 text-white items-center justify-end bg-[var(--nav-mobile-top-bar-bg)] lg:bg-gray-80 will-change-transform"
    qaid="nav-utilities-b2c"
  >
    <li v-if="!isCompactView">
      <slot name="language-country-info" />
    </li>
    <li v-if="!isCompactView">
      <slot name="profile-login" />
    </li>

    <li v-if="isCompactView">
      <nav-mobile-search-icon />
    </li>
    <li>
      <slot name="minicart" />
    </li>
  </ul>
</template>

<script>
import {mapState} from 'vuex';
import {PdlButton} from '@pedal/pdl-button';
import {PdlIcon} from '@pedal/pdl-icon';
import NavMobileSearchIcon from '@/navigation/NavMobileSearchIcon.vue';

export default {
  name: 'NavUtilitiesB2c',
  /* eslint-disable-next-line vue/no-unused-components */
  components: {PdlButton, PdlIcon, NavMobileSearchIcon},

  computed: {
    ...mapState('global', ['isCompactView']),
  },
};
</script>
<style lang="scss" scoped>
ul {
  --nav-focus-color: var(--white);
  --nav-focus-offset: 2px;
}
</style>
<style lang="scss">
#locale-selector {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 0;

  .flag-icon-squared::after {
    width: 20px;
    height: 20px;
  }
}
</style>
